import { render, staticRenderFns } from "./inputTabLampiran.vue?vue&type=template&id=28d310ba&scoped=true"
import script from "./inputTabLampiran.vue?vue&type=script&lang=js"
export * from "./inputTabLampiran.vue?vue&type=script&lang=js"
import style0 from "./inputTabLampiran.vue?vue&type=style&index=0&id=28d310ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d310ba",
  null
  
)

export default component.exports